import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { ReactNode } from 'react';

export default function GBgIcon({ children = <CheckCircleIcon className="w-6 h-6" aria-hidden="true" /> }: { children?: ReactNode }) {
  return <div className="absolute flex items-center justify-center w-12 h-12 text-white rounded-md bg-orange dark:bg-gray-700 dark:text-gray-300">{children}</div>;
}
